import React from 'react';
import { Modal, Box, Button } from '@mui/material';

interface ExitAssessmentModalProps {
    setShowExit: (show: boolean) => void;
    navigate: any;
}

const ExitAssessmentModal: React.FC<ExitAssessmentModalProps> = ({ setShowExit, navigate }) => {
    return (
        <Modal open onClose={() => setShowExit(false)}>
            <Box sx={{ p: 4, bgcolor: 'background.paper', margin: 'auto', mt: 8, width: 400 }}>
                <h2 style={{ fontSize: '20pt' }}>Exit Assessment</h2>
                <br />
                <div style={{ fontSize: '14pt' }}>Do you want to pause the test?</div>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                    <Button variant="outlined" color="error" onClick={() => setShowExit(false)}>
                        No
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => navigate('/user/dashboard', { replace: true })}
                    >
                        Yes
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ExitAssessmentModal;
